module.exports = __webpack_public_path__ + "assets/img/bottle_icon.1659b795.svg";